<div class="modal-container">
    <div class="modal-body pt-0">
      <div class="text-center">
        <!-- <app-svg-icon 
        class="mt-3 mb-3 justify-content-center text-center"
        [src]="'../../../../assets/SVGIcons/uploadesuccess.svg'"
        ></app-svg-icon> -->
        <app-svg
         class="mt-3 mb-3 justify-content-center text-center"
         iconType="UploadeSuccess" >                        
        </app-svg>
                
        <div  class="font-15 text-semi-primary mb-2">Records Added</div>
        <div   class="font-15 text-gray mb-4">Records are added to your  <br>
            mailing list.</div>    
        <div class="font-13 text-light-gray mb-3">Added Records: {{record}} Companies</div>
        <div>
      </div>
    </div>
    <div class="modal-footer border-0 justify-content-center">
        <app-button 
          [buttonType]="'submit'"  
          [button_2]="true"  
          [buttonClass]="'button popup-button button-primary m-0'" 
          (click)="applyChanges();activeModal.close()" 
          [buttonLable]="enumButtonName.OKAY">
      </app-button>
    </div>
  </div>
  